import React from 'react';

const { Provider: MovApiProvider, Consumer: MovApiConsumer } = React.createContext();

export { MovApiProvider, MovApiConsumer };
